import React from "react";
import "./BriefProfileOfBOD.css";

export default function BriefProfileOfBOD() {
  return (
    <div id="content">
      <section className="welcome padding-top-50 padding-bottom-50">
        <div className="container">
          <div className="heading blck">
            <div className="text-center">
              <h3>Our Board of Directors</h3>
              <hr />
            </div>
          </div>
          <ul className="dwbutton">
            <li>
                <a
                href="assets/investor_relation/Brief profile of BOD.pdf"
                target="_blank"
              >
                <i className="fa fa-angle-double-right"></i><b>View Details</b>: Board of Directors
              </a>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
}
